export default "__VITE_ASSET__80f5a9aa__"